import React, { useEffect, useState } from 'react';
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography
} from '@mui/material';
import { Cancel as CancelIcon } from '@mui/icons-material';
import { DataGrid } from '@mui/x-data-grid';
import { getOverallLeaveCount } from '../../services/leaveServices';
import * as XLSX from 'xlsx';

export default function OverallLeaveDialog({
  open,
  onClose,
  employees,
  selectedDialogEmployee,
  handleDialogEmployeeChange
}) {

  const [overallLeaves, setOverallLeaves] = useState([]);

  const fetchOverallLeaves = async () => {
    if (!selectedDialogEmployee) return setOverallLeaves([]);
    try {
      const overallLeaveCount = await getOverallLeaveCount(selectedDialogEmployee || 'all');
      const rows = overallLeaveCount.map((emp, index) => ({
        id: index + 1,
        employeeNumber: emp.employeeNumber,
        employeeName: emp.name,
        SL: emp.SL,
        CL: emp.CL,
        LOP: emp.LOP
      }));

      setOverallLeaves(rows);
    } catch (error) {
      console.error('Error fetching overall leave count :', error);
      setOverallLeaves([]);
    }
  };

  useEffect(() => {
    fetchOverallLeaves();
  }, [selectedDialogEmployee]);

  const columns = [
    { field: 'employeeNumber', headerName: <b>Emp ID</b>, flex: 1 },
    { field: 'employeeName', headerName: <b>Emp Name</b>, flex: 1 },
    { field: 'SL', headerName:  <b>SL</b>, flex: 0.5 },
    { field: 'CL', headerName:  <b>CL</b>, flex: 0.5 },
    { field: 'LOP', headerName: <b>LOP</b>, flex: 0.5 }
  ];

  const handleExport = () => {
    if (!overallLeaves.length) return;

    const worksheet = XLSX.utils.json_to_sheet(overallLeaves);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Overall Leaves");

    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "overall-leaves.xlsx");
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      PaperProps={{ sx: { width: '700px' }, className: 'dialog' }}
    >
      <DialogTitle className="dialogTitle">
        Overall Leave Count
        <IconButton aria-label="close" onClick={onClose} className="dialogCloseIcon">
          <CancelIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent className="dc-bottom-padding">
        <Box display="flex" justifyContent="space-between" alignItems="center" mt={2} mb={2}>
          <FormControl size="small" sx={{ minWidth: 250 }}>
            <InputLabel id="employee-select-label">Filter by Name</InputLabel>
            <Select
              value={selectedDialogEmployee || ''}
              onChange={handleDialogEmployeeChange}
              labelId="employee-select-label"
              label='>Filter by Name'
            >
              <MenuItem value="all">All</MenuItem>
              {employees.map((employee) => (
                <MenuItem key={employee._id} value={employee._id}>
                  {employee.firstName} {employee.lastName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Box display="flex" flexDirection={"column"}>
          </Box>
        </Box>

        <Box sx={{ height: 400 }}>
          <DataGrid
            rows={overallLeaves}
            columns={columns}
            disablePagination
            disableRowSelectionOnClick
            sortingMode="client"
            hideFooterPagination
            hideFooter
            disableColumnMenu
          />
        </Box>
      </DialogContent>

      <DialogActions className="dialogActions">
        <Button variant="outlined" onClick={onClose}>
          Close
        </Button>
         <Button variant="contained" onClick={handleExport}>
          Export
        </Button>
      </DialogActions>

    </Dialog>
  );
}
